import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { inferStage } from '../config';
import invariant from 'tiny-invariant';

const GAMMA_OPTIONS = {
  init: {
    distributed_tracing: { enabled: true },
    privacy: { cookies_enabled: true },
    ajax: { deny_list: ['bam.nr-data.net'] },
  },
  info: {
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    licenseKey: 'de77588fbd',
    applicationID: '772340289',
    sa: 1,
  },
  loader_config: {
    accountID: '7501',
    trustKey: '7501',
    agentID: '772340289',
    licenseKey: 'de77588fbd',
    applicationID: '772340289',
  },
};

const PROD_OPTIONS = {
  init: {
    distributed_tracing: { enabled: true },
    privacy: { cookies_enabled: true },
    ajax: { deny_list: ['bam.nr-data.net'] },
  },
  info: {
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    licenseKey: 'de77588fbd',
    applicationID: '772340294',
    sa: 1,
  },
  loader_config: {
    accountID: '7501',
    trustKey: '7501',
    agentID: '772340294',
    licenseKey: 'de77588fbd',
    applicationID: '772340294',
  },
};

let agent;

export function initializeNewRelic() {
  invariant(!agent, 'New Relic already initialized');
  const stage = inferStage();
  let options;
  switch (stage) {
    case 'gamma':
      options = GAMMA_OPTIONS;
      break;
    case 'prod':
      options = PROD_OPTIONS;
      break;
    default:
      invariant(false, `Invalid stage: ${stage}`);
  }
  agent = new BrowserAgent(options);
}
